export default "__VITE_ASSET__CAyhJEra__"